import React from 'react';
import {translate} from 'react-i18next';
import InfiniteScrollTable from "../infinite-scroll-table";

const InfiniteScrollDataTable = ({
                                   data,
                                   cols,
                                   height,
                                   hiddenCols,
                                   rowTotal,
                                   onChange,
                                   rowSelection,
                                   getRowKey,
                                   onRowClick,
                                   noFilter,
                                   noSort,
                                   isPaginated,
                                   actions,
                                   colActions,
                                   rightActions,
                                   tableActions
                                 }) =>
  <InfiniteScrollTable
    data={data}
    height={height}
    rowCount={rowTotal}
    getRowKey={getRowKey || JSON.stringify}
    columns={
      cols
        ? cols
          .filter(col => !hiddenCols || hiddenCols.filter(hiddenCol => hiddenCol === col).length === 0)
          .map(col => ({
            title: col,
            dataIndex: col,
            minWidthToContent: true,
            noFilter,
            noSort
          }))
        : null
    }
    onChange={onChange}
    isPaginated={isPaginated !== undefined ? isPaginated : true}
    autoSearch={false}
    rowSelection={rowSelection}
    onRowClick={onRowClick}
    actions={actions}
    colActions={colActions}
    rightActions={rightActions}
    tableActions={tableActions}
  />;

export default translate()(InfiniteScrollDataTable);
